import React from 'react'
import { QuestionInputProps } from '../../questionTypes'

export const DatePickerQuestion: React.FC<QuestionInputProps> = ({ question: { id: questionId }, value, onChange, readOnly = false }) => (
  <div className='survey-response-question__date'>
    <input
      id={`question-${questionId}`}
      type='date'
      className='survey-response-question__date-input'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      readOnly={readOnly}
    />
  </div>
)
